import { GradientHeading, Text } from '@components/Typography';
import { Box } from '@fastly/consistently';
import { useUrlWithUtmParams } from '@hooks/use-utm-params';
import ArtBrain from '@images/art_brain.svg';
import * as React from 'react';
import styled, { keyframes } from 'styled-components';

const Container = styled.div`
  background: var(--color-background-dark);
  padding: 1rem 1rem 0 1rem;
  border-radius: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
`;

const Heading = styled(GradientHeading).attrs({ as: 'h2' })`
  position: relative;
  margin: -1rem -1rem 0 -1rem;
  padding: 1rem;
  overflow: hidden;

  ::before {
    display: block;
    content: '';
    position: absolute;
    top: -1rem;
    right: -1rem;
    bottom: 1rem;
    left: -1rem;
    background: repeating-linear-gradient(-45deg, transparent, transparent 40px, rgba(240, 240, 240, 0.5) 41px);
  }
`;

const ButtonWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 1rem;
`;

const buttonShine = keyframes`
    from {
        box-shadow: 0px 0px 0px 0px var(--color-btn-red);
    }
    
    to {
        box-shadow: 0px 0px 30px 2px var(--color-btn-red);
    }
`;

const Button = styled.a`
  cursor: pointer;
  display: flex;
  flex-shrink: 1;
  margin-right: 1rem;
  align-items: center;
  justify-content: center;
  background: var(--color-btn-red);
  color: var(--color-white);
  font-size: 1.1rem;
  height: 3.3rem;
  border-radius: 1.65rem;
  padding: 0 1rem;
  width: 176px;
  border: 1px solid #1c2930c7;
  box-shadow: 0px 0px 2px var(--color-btn-red);
  animation: ${buttonShine} 1s linear infinite alternate;

  :hover {
    animation: pause;
    background: var(--color-btn-red-hover);
  }
`;

type Props = {
  copy: GatsbyTypes.MicrocopyFragment['registration'];
};

const MainCTA: React.FC<Props> = ({ copy }) => {
  const urlWithUtmParams = useUrlWithUtmParams(
    'https://fastly.brandlive.com/dept-of-know-speaker-series/en/registration'
  );
  return (
    <Container>
      <Box>
        <Heading>{copy?.headline}</Heading>
        <Text as="p" mode="dark" size="lg">
          {copy?.subcopy}
        </Text>
      </Box>
      <ButtonWrap>
        <Button href={urlWithUtmParams} target="_blank" data-link-id="main-cta">
          {copy?.button_text}
        </Button>
        <ArtBrain />
      </ButtonWrap>
    </Container>
  );
};

export default MainCTA;
